import React   from 'react';
import connect from 'react-redux/es/connect/connect';

class Header extends React.Component {
    render() {
        const {currentUserName, children} = this.props;
        return (
            <div className="pc-navigation">
                <div className="pc-top-navigation">
                    <div className="pc-top-navigation__logo">
                        <img src="/images/logo-justeat.svg" alt="Logo"/>
                    </div>
                    <div className="pc-top-navigation__application-name">Restaurant Capabilities</div>

                    <input type="checkbox" className="pc-toggle-top-navigation" id="pc-toggle-top-navigation"/>
                    <label className="pc-mobile-toggler" htmlFor="pc-toggle-top-navigation">
                        <span className="pc-mobile-toggler-inner"/>
                    </label>
                    <ul className="pc-top-navigation__primary-menu">
                        <li>
                            <a>
                            <span className="pc-icon pc-icon--customer"/>
                            {currentUserName}
                            </a>
                        </li>
                        <li><a href="#">Log out</a></li>
                        <li><a href="#">Help</a></li>
                    </ul>
                </div>
                <hr />
                {children}
            </div>
        );
    }
}

export default connect(state => ({
    currentUserName: state.oidc.user.profile.name
}))(Header);



// WEBPACK FOOTER //
// /src/components/Header/Header.js